import * as Sentry from "@sentry/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { APP_VERSION } from "./common/env";
import { sentryConfig } from "./common/sentryConfig";
import featureFlag from "./feature-flag";
import { getReleaseName } from "./utils/get-release-name";

interface WrapperAppProps {
  readonly children: React.ReactNode;
}

export function InitializeApp({ children }: WrapperAppProps) {
  const [isReady, setIsReady] = useState(false);

  useEffect(function initializeApp() {
    window.moment = moment;
    window.moment.locale("it");
    window.year = window.moment().year();

    if (!Sentry.isInitialized()) {
      Sentry.init(sentryConfig);
    }

    Sentry.setTag("app_version", APP_VERSION);
    Sentry.setTag("release_name", getReleaseName());

    const promisesToInitializeApp = [
      import("./index.css"),
      import("./assets/css/main.css"),
      import("./common/mixpanel-config"),
      import("./services/axios-config-singleton/axios-config-singleton"),
      // Fixes older browser compatibilities issues (https://github.com/remarkjs/react-markdown/issues/804)
      import("core-js/features/object" as any),
      import("./polyfill/promise"),
      import("./polyfill/resize-observer-polyfill"),
      featureFlag
        .initialize()
        .then(console.debug.bind(null, "Feature Flag initialized"))
        .catch(console.error.bind(null, "Feature Flag error:")),
    ];

    Promise.all(promisesToInitializeApp)
      .catch(console.error.bind(null, "Error initializing app"))
      .finally(function appIsReady() {
        setIsReady(true);
      });
  }, []);

  if (!isReady) {
    return <></>;
  }

  return <>{children}</>;
}
